import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Player } from "@lottiefiles/react-lottie-player";
import backgroundAnimation from "../../animations/Animation5.json";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/slices/authSlice";
import "./ProfilePage.css";

function ProfilePage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    console.log("user", user);
    if (!user) {
      navigate("/login");
    }
  }, [user]);

  const handleLogout = () => {
    dispatch(logout());
  };

  const formattedDate = new Date(user?.created_on).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="main-page">
      <div className="background-animation">
        <Player autoplay loop src={backgroundAnimation} />
      </div>

      <Card className="profile-card">
        <Card.Body>
          <div className="profile-header text-center">
            <img
              src={user?.image || "https://via.placeholder.com/150"}
              alt="Profile"
              className="profile-image"
            />
            <h2 className="profile-name">{user?.first_name || "Guest"}</h2>
          </div>

          <div className="profile-details">
            <p>
              <strong>Email:</strong> {user?.email}
            </p>
            <p>
              <strong>Mobile:</strong> {user?.mobile || "Not provided"}
            </p>
            <p>
              <strong>Joined On:</strong> {formattedDate || "Not provided"}
            </p>
          </div>
          <button className="logout-button" onClick={handleLogout}>
            Logout
          </button>
        </Card.Body>
      </Card>
    </div>
  );
}

export default ProfilePage;
